module.exports = __webpack_public_path__ + "media/images/sales/set/eyecatch-set-02-225088c437a9b5578b93795ccc683b59.svg";